export default __webpack_public_path__ + "static/media/cs-img.484b5d26.jpg";